<ul class="menu">
  <li *ngFor="let user of users">
    <app-user-list-item [user]="user"></app-user-list-item>
  </li>
</ul>
